import axios from 'axios'

export default {
  search: function (applicantId) {
    return axios.get('/api/vacancy/getApplicantWorks?id=' + applicantId)
  },
  find: function (id) {
    return axios.get('/api/vacancy/findApplicantWork?id=' + id)
  },
  save: function (data) {
    return axios.post('/api/vacancy/saveApplicantWork', data)
  },  
  delete: function (id) {
    return axios.delete('/api/vacancy/deleteApplicantWork?id='+id)
  },  
}